import { config } from '../config'

export function shouldUseMt5(): boolean {
  return config.whitelabel === 'tauroMarketsMauritius'
}
